<app-dialog-top>
	<i class="fa-solid fa-user-tag"></i>
	{{'ADMIN.ROLES.LABEL_ROLE' | translate}}
</app-dialog-top>

<div mat-dialog-content>
	<app-form-role-details class="h-100"
		[data]="data.data"
		[(readOnly)]="readOnly"
		[(submited)]="submited"
		(onClose)="close($event)"></app-form-role-details>
</div>

<app-dialog-bottom (onSaveClick)="onSubmit($event)" [saveDisabled]="readOnly"></app-dialog-bottom>
